import script from "./EnrolledStudents.vue?vue&type=script&setup=true&lang=js"
export * from "./EnrolledStudents.vue?vue&type=script&setup=true&lang=js"

import "./EnrolledStudents.vue?vue&type=style&index=0&id=00bb2339&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00bb2339"]])

export default __exports__